<template>
    <ReceiptLogDetail
        v-if="loaded && receiptLog"
        :receipt-log-units="receiptLogUnits"
        :receipt-log="receiptLog"
        :current-page="currentPage"
        :show-in-stock-only="showInStockOnly"
        @toggleInStockOnly="showInStockOnly = $event"
        @requestDelivery="requestDelivery"
    />
    <Page404 v-else-if="loaded" message="That Receipt Log was not found" />
</template>
<script>
import { mapState, mapActions } from "vuex";
import Page404 from "src/components/NotFoundPage.vue";
import ReceiptLogDetail from "./_components/ReceiptLogDetail.vue";
import { mutations } from "src/global-store.js";

export default {
    name: "ReceiptLogDetailModule",
    components: {
        ReceiptLogDetail,
        Page404,
    },
    data() {
        return {
            showInStockOnly: true,
            loaded: false,
            currentPage: 1,
        };
    },
    computed: {
        ...mapState("receiptLogDetail", {
            receiptLog: (state) => state.selectedReceiptLog,
        }),
        receiptLogUnits() {
            if (this.showInStockOnly) {
                return this.receiptLog.units.filter((unit) => unit.inStock);
            }
            return this.receiptLog.units;
        },
    },
    async created() {
        await this.fetchReceiptLog({ id: this.$route.params.id });
        mutations.setNavbarTitle(
            `Receipt Log #${this.receiptLog.id}`,
            this.receiptLog.customer?.name,
        );
        this.loaded = true;
    },
    methods: {
        ...mapActions("receiptLogDetail", ["fetchReceiptLog"]),
        ...mapActions("deliveryRequest", ["addToPendingReceiptLogs"]),
        requestDelivery(selectedUnits) {
            this.addToPendingReceiptLogs({
                receiptLogs: [{ ...this.receiptLog, units: selectedUnits }],
            });
        },
    },
};
</script>
